import { MapPin, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export const RelocationRoutes = () => {
  const routes = [
    {
      id: 1,
      from: "Spain",
      cities: "Barcelona, Madrid, Costa del Sol, Valencia",
      description: "Popular route for UK expats returning after retirement or work abroad. Full TOR1 support for removals from Spain to UK.",
      flag: "🇪🇸"
    },
    {
      id: 2,
      from: "France",
      cities: "Paris, Lyon, Bordeaux, Nice",
      description: "Seamless removals from France to UK with expert customs clearance. Duty-free furniture and belongings transfer.",
      flag: "🇫🇷"
    },
    {
      id: 3,
      from: "Italy",
      cities: "Rome, Milan, Florence, Turin",
      description: "Professional removals from Italy to UK. Transfer of Residence relief for all your personal belongings.",
      flag: "🇮🇹"
    },
    {
      id: 4,
      from: "Portugal",
      cities: "Lisbon, Porto, Algarve, Faro",
      description: "Removals from Portugal to UK with full TOR1 customs documentation and duty-free clearance.",
      flag: "🇵🇹"
    },
    {
      id: 5,
      from: "Germany",
      cities: "Berlin, Munich, Frankfurt, Hamburg",
      description: "Expert removals from Germany to UK. Complete Transfer of Residence application handling.",
      flag: "🇩🇪"
    },
    {
      id: 6,
      from: "Middle East & Asia",
      cities: "Dubai, Singapore, Hong Kong, Doha",
      description: "Overseas to UK removals from anywhere worldwide. TOR1 relief for long-distance relocations.",
      flag: "🌍"
    }
  ];

  return (
    <section id="relocation-routes" className="py-20 bg-white" aria-labelledby="routes-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="routes-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Popular Relocation Routes to UK
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialist TOR1 services for removals from Spain, France, Italy and overseas to the UK
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {routes.map((route) => (
            <Card 
              key={route.id} 
              className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white"
              role="article"
              aria-label={`Removals from ${route.from} to UK`}
            >
              <CardHeader>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-4xl" aria-hidden="true">{route.flag}</span>
                  <ArrowRight className="text-blue-900" size={24} aria-hidden="true" />
                  <span className="text-4xl" aria-hidden="true">🇬🇧</span>
                </div>
                <CardTitle className="text-xl">
                  {route.from} to UK Removals
                </CardTitle>
                <p className="text-sm text-gray-500 mt-1">{route.cities}</p>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {route.description}
                </p>
                <div className="mt-4 flex items-center text-blue-900 text-sm font-semibold">
                  <MapPin size={16} className="mr-2" />
                  Duty-Free Transfer
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center bg-blue-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Removals from Any Country to UK
          </h3>
          <p className="text-lg text-gray-600 mb-2">
            Not listed? We handle TOR1 Transfer of Residence for UK nationals returning from <strong>anywhere in the world</strong>.
          </p>
          <p className="text-gray-600">
            Australia, USA, Canada, New Zealand, South Africa, and all other countries - full customs clearance support.
          </p>
        </div>
      </div>
    </section>
  );
};
